module.exports = __webpack_public_path__ + "static/img/DILIUGAN.ad0279f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/pp/DILIUGAN.png
// module id = OjK1
// module chunks = 0